<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Payments</h3>
            </d-col>
        </d-row>
        <d-row v-if="checkPermission(permissionTypes.invoiceRead)">
            <d-col lg="12" class="mb-4">
                <d-card class="card-small">
                    <d-card-header>
                        <h6 class="m-0 text-muted">Overview of your payments</h6>
                    </d-card-header>
                    <invoice />
                    <d-card-footer />
                </d-card>
            </d-col>
        </d-row>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
import InvoiceTable from '@/components/table/InvoiceTable.vue';
import permissions from '../../mixins/permissions';

export default {
    mixins: [permissions],
    components: {
        invoice: InvoiceTable,
    },
};
</script>
